import { KeycloakAuthResourcesConfig } from '@elotech/angular-common';
import { environment } from './../environments/environment';
import { Injectable } from "@angular/core";

const permissions = require('./permissions.json');

@Injectable()
export class KeycloakAuthConfig implements KeycloakAuthResourcesConfig {
  realm: string = environment.realm;
  url: string = environment.urlKeycloak;
  resource: string = 'portal-servidor';
  clientId: string = 'portal-servidor';
  'ssl-required': string = 'external';
  'public-client': boolean = true;
  'confidential-port': number = 0;
  'enable-cors': boolean = true;
  permissions: any[] = permissions;
  adminRealmRole: string = 'portal_servidor_user';
  resourceRole: string = 'folha-pagamento-backend';
  userInfoCookieKey: string = 'authorization_usuarioinfo_portal_servidor';
}
